import { FormFieldType, UserType } from '../../../views/formularios/interfaces/forms';

export const formFieldTypeLabel: Record<FormFieldType, string> = {
  TEXT_SHORT: 'Texto curto',
  TEXT_LONG: 'Texto longo',
  SINGLE_CHOICE: 'Seleção única',
  MULTIPLE_CHOICE: 'Múltipla escolha',
  SCALE: 'Escala numérica',
};

export const formFieldTypeList: FormFieldType[] = [
  'TEXT_SHORT',
  'TEXT_LONG',
  'SINGLE_CHOICE',
  'MULTIPLE_CHOICE',
  'SCALE',
];

export const fieldNeedsOptions = (type: FormFieldType): boolean =>
  type === 'SINGLE_CHOICE' || type === 'MULTIPLE_CHOICE';

export const fieldNeedsScale = (type: FormFieldType): boolean => type === 'SCALE';

export const userTypeLabel: Record<UserType, string> = {
  RECEPCAO: 'Recepção',
  CHEFE_DE_OFICINA: 'Chefe de Oficina',
  ORCAMENTO: 'Orçamento',
  ESTOQUE: 'Estoque',
  COMPRA: 'Compra',
  COLABORADOR: 'Colaborador',
  CONSULTOR: 'Consultor',
  REGIONAL: 'Regional',
  RELACIONAMENTO: 'Relacionamento',
  CONTAC: 'Contac',
  COMISSIONAMENTO: 'Comissionamento',
  ADMIN: 'Administrador',
  ADMINISTRACAO: 'Administração',
  TI: 'TI',
};

/**
 * at-67 (BUG-V30): papéis que realmente alcançam a tela de Formulários.
 *
 * O construtor oferecia os 13 papéis do sistema como "autorizados a responder", incluindo
 * **RELACIONAMENTO, CONTAC e ADMINISTRACAO** — que não estão no `RoleGuard` da rota
 * `/formularios` (`App.tsx`). Marcar um deles produzia uma autorização que nunca se
 * realiza: o formulário fica atribuído a quem não consegue nem abrir a tela, e ninguém
 * descobre — só some da fila de quem deveria responder.
 *
 * ⚠️ Espelha o `requiredRoles` do `RoleGuard` de `/formularios`. Mudou lá, mude aqui.
 * (ADMIN fica de fora da lista porque não é oferecido no construtor: ele já acessa tudo.)
 */
export const papeisComAcessoAFormularios: UserType[] = [
  'RECEPCAO',
  'CHEFE_DE_OFICINA',
  'COLABORADOR',
  'ORCAMENTO',
  'COMPRA',
  'ESTOQUE',
  'CONSULTOR',
  'REGIONAL',
  'COMISSIONAMENTO',
  'TI',
];

export const userTypeList: UserType[] = [
  'RECEPCAO',
  'CHEFE_DE_OFICINA',
  'COLABORADOR',
  'ORCAMENTO',
  'COMPRA',
  'ESTOQUE',
  'CONSULTOR',
  'REGIONAL',
  'RELACIONAMENTO',
  'CONTAC',
  'COMISSIONAMENTO',
  'ADMINISTRACAO',
  'TI',
  'ADMIN',
];
